import React from "react";
import { Link as GatsbyLink } from "gatsby";

import type { LinkProps } from "@bared/ui";

import { useHref } from "~/hooks/useHref";

export function Link({
  href = "",
  onClick,
  className,
  onMouseOut,
  onMouseOver,
  activeClassName,
  partiallyActive,
  children,
  external,
  ...props
}: LinkProps) {
  const to = useHref(href ?? "/");

  // Render an ordinary anchor for external links.
  // Use "href" here, not "to" as the useHref hook is not aware of the "external" prop.
  if (!!external || to.startsWith("http")) {
    return (
      <a href={to} className={className} {...props}>
        {children}
      </a>
    );
  }

  // Render a GatsbyLink for internal links.
  return (
    /** @ts-expect-error Ref incompatibility */
    <GatsbyLink
      to={to}
      onClick={onClick}
      className={className}
      onMouseOut={onMouseOut}
      onMouseOver={onMouseOver}
      activeClassName={activeClassName}
      partiallyActive={partiallyActive}
      {...props}
    >
      {children}
    </GatsbyLink>
  );
}
